/**
 * Reviews Slider Section
 */

class ReviewsSlider {
  constructor(section) {
    this.section = section;
    this.swiperContainer = section.querySelector('.section-reviews-slider__swiper');

    if (!this.swiperContainer) return;

    this.init();
  }

  init() {
    // Wait for Swiper to be available
    if (typeof Swiper === 'undefined') {
      console.error('Swiper library not loaded');
      return;
    }

    this.swiper = new Swiper(this.swiperContainer, {
      slidesPerView: 'auto',
      spaceBetween: 18,
      centeredSlides: false,
      loop: false,
      speed: 600,
      initialSlide: 2,

      navigation: {
        nextEl: '.section-reviews-slider__nav-next',
        prevEl: '.section-reviews-slider__nav-prev',
      },

      pagination: {
        el: '.section-reviews-slider__pagination',
        clickable: true,
        dynamicBullets: false,
      },

      breakpoints: {
        // Mobile
        0: {
          slidesPerView: 'auto',
          spaceBetween: 18,
          centeredSlides: true,
        },
        // Tablet
        750: {
          slidesPerView: 2,
          spaceBetween: 18,
          centeredSlides: false,
        },
        // Desktop
        990: {
          slidesPerView: 'auto',
          spaceBetween: 18,
          centeredSlides: false,
        },
      },

      on: {
        init: function () {
          // Add smooth transition
          this.wrapperEl.style.transitionTimingFunction = 'cubic-bezier(0.25, 0.46, 0.45, 0.94)';
        },
      },
    });
  }

  destroy() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
    }
  }
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[data-section-type="w-reviews-slider"]');
  sections.forEach(section => {
    new ReviewsSlider(section);
  });
});

// Shopify theme editor support
if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target;
    if (section.querySelector('[data-section-type="w-reviews-slider"]')) {
      new ReviewsSlider(section);
    }
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target;
    const swiperEl = section.querySelector('.section-reviews-slider__swiper');
    if (swiperEl && swiperEl.swiper) {
      swiperEl.swiper.destroy(true, true);
    }
  });
}
